export const DHtmlElementState = wcardinal.ui.DHtmlElementState;